

















import { renderNews } from "@/services/news/newsService";
import { LanguageEnum, NewsRenderModel } from "@/services/news/types";
import { Component, Vue } from "vue-property-decorator";
import SingleNewsRender from "../SingleNewsRender.vue";

@Component({
    components: {
        SingleNewsRender
    }
})
export default class NewsPreviewModal extends Vue {
    id: string = "";
    name: string = ""
    newsRenderModel = {} as NewsRenderModel;
    languages = Object.keys(LanguageEnum).map((key: any) => LanguageEnum[key]).filter(value => typeof value === "string") as string[];
    language = "";
    reload = 0;

    open(id: string, name: string) {
        this.language = this.languages[0];
        this.id = id;
        this.name = name;
        this.$bvModal.show("modal-previewNews");
        renderNews(this.id, this.language).then((data: NewsRenderModel) => {
            this.newsRenderModel = data;
            this.language = (data.content as any).language;
        });
    }

    changeLanguage() {
        renderNews(this.id, this.language).then((data: NewsRenderModel) => {
            this.newsRenderModel = data;
            this.reload++;
        });
    }
}
